import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment'
import { Bom } from "../constant/bom"
import { retry, catchError } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class BomService {

  public apiUrl = environment.api

  constructor(
    private httpClient: HttpClient
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json'
    })
  }

   /**
   * getBoms
   */
  public getBoms(): Observable<Bom> {
    return this.httpClient.get<Bom>(
      this.apiUrl + 'bom/getAll',
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * getBomsByEntreprise
   */
  public getBomsByEntreprise(data): Observable<Bom> {
    return this.httpClient.post<Bom>(
      this.apiUrl + 'bom/getAllByEntreprise',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * addBoms
   */
  public addBoms(data): Observable<Bom> {
    return this.httpClient.post<Bom>(
      this.apiUrl + 'bom/add',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * updateBoms
   */
  public updateBoms(data): Observable<Bom> {
    return this.httpClient.post<Bom>(
      this.apiUrl + 'bom/update',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * deleteBoms
   */
  public deleteBoms(data): Observable<Bom> {
    return this.httpClient.post<Bom>(
      this.apiUrl + 'bom/delete',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  // Error handling
  public handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(['Erreur HTTP', errorMessage]);
    return throwError(errorMessage);
  }
}
